import { Currency } from 'utilities/currency'

import { Amount, MetaInformation, Processed } from './event-information'

export interface GapPaymentProps {
  currency: Currency
  date: string
  operation: any
}

export const GapPayment = ({ currency, date, operation }: GapPaymentProps) => (
  <MetaInformation>
    <Amount currency={currency} value={operation.gapPaymentValue} />
    <Processed date={date} operationState="Completed" />
  </MetaInformation>
)
